export const RESUME_LILNK =
  "https://drive.google.com/file/d/1tQxvBfx6cZ8sXyy5n0P6BRDh2VFzHJqp/view?usp=drive_link";
export const SECTION_ITEMS = [
  {
    title: "About Me",
    id: "aboutMe",
  },
  {
    title: "Articles",
    id: "cards-container",
  },
  {
    title: "Experience",
    id: "experience-container",
  },
  {
    title: "Skills & Tools",
    id: "skills-container",
  },
  {
    title: "Contact Me",
    id: "contactme",
  },
];

export const LANGUAGES = [
  {
    name: "HTML5",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
  },
  {
    name: "CSS3",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
  },
  {
    name: "JavaScript",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  {
    name: "Java",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
  },
  {
    name: "Kotlin",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg",
  },
];

export const FRAMEWORKS = [
  {
    name: "React",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  },
  {
    name: "React Native",
    img: "https://reactnative.dev/img/header_logo.svg",
  },
  {
    name: "Electron",
    img: "https://logo.svgcdn.com/l/electron.png",
  },
  {
    name: "Jenkins",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
  },
  {
    name: "Xcode",
    img: "https://developer.apple.com/assets/elements/icons/xcode/xcode-128x128_2x.png",
  },
];

export const TOOLS = [
  {
    name: "Git",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
  },
  {
    name: "Jenkins",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
  },
  {
    name: "Xcode",
    img: "https://developer.apple.com/assets/elements/icons/xcode/xcode-128x128_2x.png",
  },

  {
    name: "Docker",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
  },
  {
    name: "VS Code",
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
  },
  {
    name: "React",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  },
  {
    name: "JavaScript",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  {
    name: "TypeScript",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
  },
  {
    name: "Redux",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
  },
  {
    name: "Zustand",
    url: "https://cdn.worldvectorlogo.com/logos/stellar.svg",
  },
  {
    name: "Expo",
    url: "https://cdn.worldvectorlogo.com/logos/expo-1.svg",
  },
  {
    name: "CSS3",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
  },
  {
    name: "HTML5",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
  },
  {
    name: "Git",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
  },
  {
    name: "GitHub",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
  },
  {
    name: "Docker",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
  },
  {
    name: "Firebase",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
  },
  {
    name: "Jest",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jest/jest-plain.svg",
  },
  {
    name: "Automation",
    url: "https://www.svgrepo.com/show/409864/automation.svg",
  },
  {
    name: "CI/CD",
    url: "https://www.svgrepo.com/show/372275/ci-cd.svg",
  },
  {
    name: "Jenkins",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
  },
  {
    name: "iOS",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apple/apple-original.svg",
  },
  {
    name: "Cloud",
    url: "https://cdn.worldvectorlogo.com/logos/google-cloud.svg",
  },
  {
    name: "App Store",
    url: "https://cdn.worldvectorlogo.com/logos/apple-app-store.svg",
  },
  {
    name: "Play Store",
    url: "https://cdn.worldvectorlogo.com/logos/google-play-5.svg",
  },
  {
    name: "GraphQL",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg",
  },
  {
    name: "AWS",
    url: "https://cdn.worldvectorlogo.com/logos/amazon-web-services-2.svg",
  },
  {
    name: "Android Studio",
    url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/androidstudio/androidstudio-original.svg",
  },
  {
    name: "CodePush",
    url: "https://cdn.worldvectorlogo.com/logos/microsoft-visual-studio-app-center.svg",
  },
  {
    name: "Sentry",
    url: "https://cdn.jsdelivr.net/gh/walkxcode/dashboard-icons@master/svg/sentry.svg",
  },
];

export const ARTICLES_LINK = [
  "https://medium.com/@abhishekhm777/dynamically-change-the-app-launcher-icon-in-react-native-apps-without-any-library-1fde7abeee19",
  "https://medium.com/@abhishekhm777/accelerating-ios-or-react-native-development-with-xcode-cloud-ci-cd-c80d032dacd5",
  "",
  "https://medium.com/@abhishekhm777/bridgeless-mode-react-native-0-74-a3b801f6b973",
];
